const NoEvalsPage = () => {
  return (
    <div className="main-body-page grow" data-testid="no-evals-page">
      <h2>No Evals Found</h2>
      <p>Sorry, there are not evals at this time.</p>
    </div>
  );
};

export default NoEvalsPage;
